import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import Button from '../../../../../common/components/Button';
import {
    CALCULATOR,
    CALCULATOR_MX,
    ERROR,
    GLOBAL,
    LOAN_APPLICATION_MX,
    TURBO_SIMULATOR
} from '../../../../constants/LabelConstants';
import {formatCurrency} from '../../../../utils/CurrencyUtils';
import {TurboCashCalculator, TurboCashCalculatorStepState} from '../../../../types/mx/creditoReal/components';
import OptionsMonthly from '../../../../../common/components/OptionsMonthly';
import {Catalog} from '../../../../../common/types/common';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import InputRange from '../../../../../common/components/InputRange';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import Options from '../../../../../common/components/Options';
import {splitDecimal} from '../../../../../common/utils/NumberUtils';
import {pushDataLayer} from '../../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../../common/constants/LabelConstants';
import {COUNTRY_INITIALS} from '../../../../../common/constants/AppConstants';

class TurboCashSimulatorView extends React.Component<TurboCashCalculator, TurboCashCalculatorStepState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
            pushDataLayer(DATA_LAYER.QUOTE_TURBO_CASH);
        }, 200);
    }

    onPressAcceptQuote = () => {
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    checkIfPressNext = () => {
        if (this.props.hasCalculatorFieldsError) {
            return this.props.onPressAcceptQuote();
        }
    }

    renderQuotas = () => {
        const {defaultMonthlyPayment, monthlyPayments, monthlyPaymentField} = this.props;
        const defaultMonthlyPaymentItem = defaultMonthlyPayment.find((monthlyPayment, index) => index === 0);
        const monthlyQuotaValue = !!monthlyPayments ? monthlyPayments.find(monthlyPayment =>
            monthlyPayment.value === monthlyPaymentField.value.value
        ) : '';
        return <React.Fragment>
            <div className="row monthly-quotes">
                <div className="col">
                    <div className="row">
                        <div className="col title-quotes">{CALCULATOR_MX.MONTHLY_PAYMENTS_SIMULATOR}</div>
                    </div>
                    {!monthlyQuotaValue && <div className="row">
                        <div className="col sub-title-quotes d-flex align-items-center justify-content-center">
                            {CALCULATOR_MX.MONTHLY_PAYMENTS_DETAIL_SIMULATOR}
                        </div>
                    </div>}
                    {monthlyQuotaValue && <div className="row">
                        <div className="col value-quotes d-flex align-items-center justify-content-center">
                            {!!monthlyQuotaValue.label && splitDecimal(monthlyQuotaValue.label[1]).integerPart}
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col">
                            <OptionsMonthly id={'quotas'}
                                            name={'quotas'}
                                            options={this.props.monthlyPayments || this.props.defaultMonthlyPayment}
                                            required={true}
                                            hasError={this.state.showErrors}
                                            labelError={this.props.monthlyPaymentField.error}
                                            onChange={this.props.onChangeMonthlyPayment}
                                            defaultValue={this.props.monthlyPaymentField.value.value ||
                                            defaultMonthlyPaymentItem.value}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row financing-details">
                <div className="col">
                    {
                        this.props.isInsuranceInFinancing ?
                            <div className="row section-details border-bottom mt-3 pb-3">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">{CALCULATOR_MX.ANNUAL_INSURANCE}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col description mb-2">
                                            {this.props.isInsuranceInFinancing ?
                                                CALCULATOR_MX.ANNUAL_INSURANCE_INCLUDED_MONTHLY_PAYMENT :
                                                ''}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">{this.props.insuranceAmount || '$ — —'}</div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                    <div className="row section-details mt-2 pb-2">
                        <div className="col">
                            <div className="row">
                                <div className="col title">{CALCULATOR_MX.FINANCING_AMOUNT}</div>
                            </div>
                            <div className="row">
                                <div className="col description mb-2">
                                    {`${CALCULATOR_MX.FINANCING_AMOUNT_DETAIL}`}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col value">{this.props.financingAmount || '$ — —'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col title-header">{CALCULATOR_MX.CASH_PAYMENTS}:</div>
                    </div>
                    {
                        this.props.isInsuranceInFinancing ? null :
                            <div className="row section-details mt-2 pb-2">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">{CALCULATOR_MX.ANNUAL_INSURANCE}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">{this.props.insuranceAmount || '$ — —'}</div>
                                    </div>
                                </div>
                            </div>
                    }
                    <div className="row section-details mt-2 pb-2">
                        <div className="col">
                            <div className="row">
                                <div className="col title">{CALCULATOR_MX.COMMISSION_AMOUNT_TURBO_CASH}</div>
                            </div>
                            <div className="row">
                                <div className="col description">
                                    {CALCULATOR_MX.COMMISSION_AMOUNT_DETAIL_SIMULATOR_TURBO_CASH}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col value">{this.props.commissionAmount || '$ — —'}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }

    onChangeYear = (year: number, error: string, maxYear: number) => {
        const {onChangeYear, years} = this.props;
        const yearLength: number = year.toString().length;
        const strMaxYear: string = maxYear.toString();
        const strYear: string = year.toString();
        const maxYearCatalog = !!!year ? {id: strMaxYear, value: strMaxYear, payload: ''} : {
            id: strYear,
            value: strYear,
            payload: ''
        };
        if (yearLength === 4) {
            const yearFound: Catalog = years.find(y => y.value === strYear);
            const yearSelected = !!yearFound ? yearFound : maxYearCatalog;
            const newError: string = !!yearFound ? error : ValidateConstant.YEAR_OUT_OF_RANGE;

            onChangeYear(yearSelected, newError);
        } else {
            onChangeYear(maxYearCatalog, !!year ? error : null);
        }
    }

    render() {
        const {
            priceField, minPrice, downPaymentField,
            minDownPaymentValue, years, yearSelectedField, maxDownPayment
        } = this.props;
        const priceSelected: string = priceField.value;
        const downPaymentSelected: string = downPaymentField.value;
        const yearValues: number[] = years.length > 0 ? years.map(y => parseInt(y.value, 10)) : [0];
        const minYear: number = Math.min(...yearValues);
        const maxYear: number = Math.max(...yearValues);
        const selectedYear: string = yearSelectedField.value.value;
        const maxRange: number = Math.trunc(parseFloat(priceSelected) * maxDownPayment) || 0;
        return (
            <React.Fragment>
                <div className="d-lg-none d-xl-none mb-3 motorfy-logo-turbo">
                    <img src={AssetsManager('/assets/images/wizard/motorfy-iso-primary.svg')} alt=""/>
                </div>
                <div className="wizard-turbo-title">
                    <h3 className="mt-4 mb-1 text-raleway text-secondary-lighten-1">
                        Tu solicitud de crédito ha sido pre aprobada
                    </h3>
                    <span className="regular-text sub-title">
                        Estas a un paso de conseguirlo.
                        Si estas de acuerdo acepta la nueva cotización adaptada a tu perfil.
                    </span>
                </div>
                <div className="wizard-turbo">
                    <div className="row m-0 p-0">
                        <div className="col side-form">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'enganche'}
                                                min={parseInt(this.props.minDownPaymentValue, 10)}
                                                max={maxRange}
                                                label={CALCULATOR.ENTRY_MX}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minDownPaymentValue, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.downPaymentField.error}
                                                defaultValue={downPaymentSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangeDownPayment}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'precio'}
                                                min={minPrice} max={9999999}
                                                label={CALCULATOR.PRICE}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minPrice, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.priceField.error}
                                                defaultValue={priceSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                disabled={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangePrice}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'year'}
                                                min={minYear} max={maxYear}
                                                maxLength={4}
                                                label={CALCULATOR.YEAR}
                                                required={true}
                                                disabled={true}
                                                step={1}
                                                helpText={!!yearSelectedField.error ?
                                                    `Mínimo ${minYear}, Máximo ${maxYear}` : ''}
                                                showValueOnMouseUp={false}
                                                hasError={this.state.showErrors}
                                                labelError={this.props.yearSelectedField.error}
                                                defaultValue={selectedYear}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                onChangeBox={(value, error) =>
                                                    this.onChangeYear(value, error, maxYear)}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'brand'}
                                        label={CALCULATOR.BRAND}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.brandSelectedField.value}
                                        data={this.props.brands}
                                        required={true}
                                        disabled={true}
                                        onChange={this.props.onChangeBrand}
                                        labelError={this.props.brandSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'model'}
                                        label={CALCULATOR.MODEL}
                                        placeholder={GLOBAL.SELECT}
                                        disabled={true}
                                        value={this.props.modelSelectedField.value}
                                        data={this.props.models}
                                        required={true}
                                        onChange={this.props.onChangeModel}
                                        labelError={this.props.modelSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'version'}
                                        label={CALCULATOR.VERSION}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.versionSelectedField.value}
                                        data={this.props.versions}
                                        required={true}
                                        disabled={true}
                                        onChange={this.props.onChangeVersion}
                                        labelError={this.props.versionSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'state'}
                                        label={LOAN_APPLICATION_MX.STATE}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.provinceSelectedField.value}
                                        data={this.props.provinces}
                                        required={true}
                                        disabled={true}
                                        onChange={this.props.onChangeState}
                                        labelError={this.props.provinceSelectedField.error}
                                        hasError={this.state.showErrors}/>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <Options id={'insurances'}
                                             name={'insurances'}
                                             options={this.props.insuranceIncludesOptions}
                                             onChange={this.props.onChangeIncludeInsurance}
                                             listGroupClass="list-group-borderless"
                                             customClassLabel="text-initial"
                                             defaultValue={this.props.hasInsurance}/>
                                    {this.props.failInsurance &&
                                    <strong className="form-text is-invalid">{ERROR.NO_BITUAJ_RESULT_WARNING}</strong>
                                    }
                                </div>
                            </div>
                            <div className="row turbo-wizard-info">
                                <div className="col">
                                    *La mensualidad puede cambiar dependiendo de la cotización final del seguro.
                                    Incluye: Dispositivo de rastreo.
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 side-calculator">
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col">
                                            {this.renderQuotas()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2 mb-3">
                    <div className="col col-md-6 mt-4">
                        <Button text={TURBO_SIMULATOR.NOT_ACCEPT_QUOTE} onPress={this.props.onPressNoAcceptQuote}
                                customClass="rounded btn-block px-md-5 btn-outline-info"/>
                    </div>
                    <div className="col col-md-6 d-flex justify-content-end mt-4 order-btn-simulator">
                        <Button text={TURBO_SIMULATOR.ACCEPT_QUOTE} onPress={this.onPressAcceptQuote}
                                customClass="btn-block px-md-5"/>
                    </div>
                </div>
                <div className="row mt-2 mb-3 wizard-turbo-footer">
                    <div className="col d-flex justify-content-between mt-5">
                        <p className="footer-text">Si tienes dudas llámanos al (55) 4161-8830</p>
                        <p className="text-muted small text-center text-md-right">
                            Con el respaldo de:
                            <a href="http://www.seminuevos.com/">
                                <img className="navbar-brand-img-md pl-1" alt="seminuevos"
                                     src={AssetsManager('/assets/images/common/logo-seminuevos.svg')}/>
                            </a>
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TurboCashSimulatorView;